// extracted by mini-css-extract-plugin
export default {"main":"HomeHeroSection_main__TXTQo","video":"HomeHeroSection_video__yteLp","text":"HomeHeroSection_text__tpHYd"};